import React, { useEffect, useMemo } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Trans } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useStoreState } from '@store';
import Translation from '@common/translation';


const PaymentMethodExpiredModal = () => {
  const { isAuthenticated, isCardExpired, userInfo, isExpiredSoon, expireSoon } = useStoreState((state) => state.user);
  const { addToast, removeToast, removeAllToasts } = useToasts();
  const location = useLocation();


  const [id, idExpireSoon, expireSoonDays, isAccountPage] = useMemo(() => [
    userInfo && `isExpiredId-${(userInfo as any)?.id}`,
    userInfo && `isExpireSoonId-${(userInfo as any)?.id}`,
    expireSoon && expireSoon?.expire_soon_days,
    location.pathname == '/auth/myaccount',
  ], [userInfo, expireSoon, location]);

  const ExpiredMessage = (
    <div className={'flex flex-col'}>
      <Translation use={'Your VIP access is at risk!'} className={'font-bold'} as={'div'} />
      <Translation use={'The last payment could not be processed.'} as={'div'} />
      <div>
        <Trans i18nKey={'Please act now and update your payment information.'}>
          <a href={'/auth/myaccount'} rel="noopener noreferrer" className={'text-primary'}>
            <Translation use={'update your payment information'} />
          </a>
        </Trans>
      </div>
    </div>
  );

  const ExpireSoonMessage = (
    <div className={'flex flex-col'}>
      <Translation use={'Attention, your payment method is about to expire in X days!'} as={'div'}
                   className={'font-bold'} params={{ days: expireSoonDays }} />
      <div>
        <Trans i18nKey={'Please update your credit card information to secure your VIP access.'}>
          <a href={'/auth/myaccount'} rel="noopener noreferrer" className={'text-primary'}>
            <Translation use={'update'} />
          </a>
        </Trans>
      </div>
    </div>
  );

  useEffect(() => {
    if (!isAuthenticated) {
      removeAllToasts();
      return;
    }
    if (!isExpiredSoon || !expireSoon || isAccountPage) {
      idExpireSoon && removeToast(idExpireSoon);
      return;
    }
    addToast(ExpireSoonMessage, {
      appearance: 'warning',
      id: idExpireSoon,
      autoDismiss: false,
      onDismiss: () => {
      },
      className: 'expireSoonCardToast',
    });
  }, [isAuthenticated, isAccountPage, isExpiredSoon, expireSoon, idExpireSoon, addToast, ExpireSoonMessage, removeAllToasts, removeToast]);

  useEffect(() => {
    if (!isAuthenticated) {
      removeAllToasts();
      return;
    }
    if (!isCardExpired || isAccountPage) {
      id && removeToast(id);
      return;
    }
    addToast(ExpiredMessage, {
      appearance: 'error',
      id,
      autoDismiss: false,
      onDismiss: () => {
      },
      className: 'expiredCardToast',
    });
  }, [isAuthenticated, isCardExpired, id, isAccountPage, ExpiredMessage, addToast, removeAllToasts, removeToast]);

  return <></>;
};

export default PaymentMethodExpiredModal;